import { useCallback } from 'react';

import {
  getScrollObserverEntryElement,
  getScrollObserverRootElement,
} from '../utils/scrollObserver';

import type {
  ScrollObserverEntryId,
  ScrollObserverRootId,
} from '../provider/ScrollObserverProvider';

type UseHandleScrollToEntryProps = {
  entryIds: ScrollObserverEntryId[];
  rootId: ScrollObserverRootId;
  offsetTop?: number;
};

export default function useHandleScrollToEntry({
  entryIds,
  rootId,
  offsetTop = 0,
}: UseHandleScrollToEntryProps) {
  return useCallback(
    (entryId: ScrollObserverEntryId) => {
      const rootElement = getScrollObserverRootElement(rootId);
      const entryElement = getScrollObserverEntryElement(entryId);
      if (rootElement && entryElement) {
        if (entryId === entryIds[0]) {
          rootElement.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
          const entryOffsetTop = entryElement.offsetTop;

          if (entryOffsetTop) {
            rootElement.scrollTo({ top: entryOffsetTop - offsetTop, behavior: 'smooth' });
          } else {
            entryElement.scrollIntoView({ behavior: 'smooth' });
          }
        }
      }
    },
    [entryIds, offsetTop, rootId],
  );
}
